interface GetDescriptiveTextProps {
  title?: string;
  link?: {
    target?: '_blank' | undefined;
    rel?: 'noreferrer' | undefined;
    href: string;
  };
  slug?: string;
}

export const getDescriptiveText = ({
  link,
  title,
  slug,
}: GetDescriptiveTextProps): {
  descriptiveText: string;
} => {
  if (!title) return { descriptiveText: '' };

  const formattedButtonText = title.toLowerCase().trim();

  const genericPhrases = ['learn more', 'read more'];

  if (!genericPhrases.includes(formattedButtonText)) {
    return { descriptiveText: '' };
  }

  let urlSegments = [];

  if (link && link.href) {
    urlSegments = link.href.split('/').filter(Boolean);
  } else if (slug) {
    urlSegments = slug.split('/').filter(Boolean);
  } else {
    return { descriptiveText: '' };
  }

  const lastSegment = urlSegments[urlSegments.length - 1];

  if (!lastSegment) return { descriptiveText: '' };

  const formattedSegment = lastSegment
    .replace(/[^a-zA-Z0-9]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return {
    descriptiveText: formattedSegment ? `Learn more about ${formattedSegment}` : '',
  };
};
